/**
 * pluginRegistry.ts - Plugin registry compatibility layer
 * 
 * DEPRECATED: This file provides backward compatibility for old interfacr code.
 * New code should use @opcentral/pluggr directly.
 * 
 * TODO: Refactor GlobalSamplesPanel to use pluggr properly
 */

export interface Plugin {
  id: string;
  name: string;
  enabled: boolean;
  samples?: any[];
  [key: string]: any;
}

// Global plugin registry (temporary until proper pluggr integration)
const plugins: Plugin[] = [];

export function registerPlugin(plugin: Plugin): void {
  const existing = plugins.findIndex(p => p.id === plugin.id);
  if (existing >= 0) {
    plugins[existing] = plugin;
  } else {
    plugins.push(plugin);
  }
}

export function getEnabledPlugins(): Plugin[] {
  return plugins.filter(p => p.enabled);
}

export function getAllPlugins(): Plugin[] {
  return [...plugins];
}

export function getPlugin(id: string): Plugin | undefined {
  return plugins.find(p => p.id === id);
}
